import React from 'react';
import PropTypes from 'prop-types';
import css from './Sidebar.css';
import Overlay from './Overlay';
import FocusTrap from 'focus-trap-react';

export default class Sidebar extends React.Component {

  constructor(props) {
    super(props);
  }


  get sidebarClass() {
    return `${css['sidebar-container']} ${this.props.visible ? css['expanded'] : ''} ${css[this.props.direction]}`;
  }

  get ariaHidden() {
    return this.props.visible ? null : true;
  }

  get ariaExpanded() {
    return this.props.visible ? "true" : "false";
  }

  get visibility() {
    return this.props.visible ? "visible" : "hidden";
  }

  render() {

    let trapClass = 'trap';
    if (this.props.visible && this.props.focusTrapActive) trapClass += ' is-active'; 

    return (
      <FocusTrap tag={"section"}
        active={this.props.visible && this.props.focusTrapActive}
        className={trapClass}
      >
      <div
        style={{visibility: this.visibility}}
        className={this.sidebarClass}
        aria-hidden={this.ariaHidden}
        aria-expanded={this.ariaExpanded}>
        {this.props.children}
        <Overlay visible={this.props.visible} onClick={this.props.onClose} />
      </div>
    </FocusTrap>
    );
  }
}

Sidebar.defaultProps = {
  direction: 'left'
};

Sidebar.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  focusTrapActive: PropTypes.bool.isRequired,
  children: PropTypes.object.isRequired,
  direction: PropTypes.oneOf(['top', 'left'])
};
